import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const CouponSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default CouponSVG;
